import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const softwareFormBuilderClassicRoute: InvariantJiraRoute = {
	name: 'software-form-builder-classic',
	path: '/jira/software/c/projects/:projectKey/form/:formId/builder',
	exact: true,
};
